module.exports = __webpack_public_path__ + "img/Gonta.88ad63cb.png";